import { getClass, isClassOf, isNoValue } from "../../library-js/tools/TypeUtilities";
import { InspectorCreationInfo } from "./InspectorCreationInfo";

export interface CustomCreatorClassConstructor
{
  createInspectorField( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, parent:Element ):void  
}

export class InspectorCustomClassCreator
{
  handles( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, parent:Element )
  {
    let currentClass = getClass( info.object ) as any as CustomCreatorClassConstructor;

    if ( ! currentClass )
    {
      return;
    }
    
    if ( currentClass && ! currentClass.createInspectorField )
    {
      return false;
    }

    currentClass.createInspectorField( parentInfo, info, parent );
    return true;
  }
}